<template>
  <div class="pageContainer">
    <div ref="n">
      <Navbar />
    </div>
    <div class="pageBody" v-cloak>
      <div class="detailsContainer">
        <a href="mailto:austinelwell99@gmail.com" class="linkText" ref="e"><font-awesome-icon icon="envelope" class="contactIcon" />austinelwell99@gmail.com</a>
        <a href="https://www.linkedin.com/in/austin-elwell/" target="_blank" class="linkText" ref="l"><font-awesome-icon :icon="[ 'fab', 'linkedin' ]" class="contactIcon" />linkedin</a>
        <a href="https://github.com/austinelwell99" target="_blank" class="linkText" ref="g"><font-awesome-icon :icon="[ 'fab', 'github' ]" class="contactIcon" />github</a>
        <Resume :pose="isVisible ? 'visible' : 'hidden'" href="https://drive.google.com/file/d/1Vg5UM-WqJQpLCmuBC65OrCYdaNkc05zT" target="_blank"  class="viewResume">VIEW RÉSUMÉ</Resume>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import { tween, styler} from 'popmotion';
import posed from 'vue-pose';

export default {
  name: 'Contact',
  components: {
    Navbar,
    Resume: posed.a({
      init: {
        marginTop: '20px',
      },
      visible: { opacity: 1, x: 0, scale: 1},
      hidden: { opacity: 0, x: 50 },
      hoverable: true,
      hover: { scale: 1.05, transition: { duration: 300 } },
    }),
  },
  data() {
    return {
      animateNavbar: false,
      isVisible: false,
    }
  },
  beforeRouteEnter(to, from, next) {
    //gets the previous page so we know whether to animate
    next(vm => {
      vm.prevRoute = from.path
    })
  },
  mounted() {

    setInterval(() => {
      this.isVisible = true;
    }, 1200);


    //animates navbar if coming from entry page or new window
    let n = styler(this.$refs.n)
    if ([undefined, '/'].includes(this.prevRoute)) {
      tween({
        from: {
          opacity: 0,
          y: '50px',
        },
        to: {
          opacity: 1,
          y: '0px',
        },
        duration: 500,
      }).start(n.set)
    }

    let e = styler(this.$refs.e)
    tween({
      from: {
        opacity: 0,
        x: '50px',
      },
      to: {
        opacity: 1,
        x: '0px',
      },
      elapsed: -300,
      duration: 200,
    }).start(e.set)

    let l = styler(this.$refs.l)
    tween({
      from: {
        opacity: 0,
        x: '50px',
      },
      to: {
        opacity: 1,
        x: '0px',
      },
      elapsed: -600,
      duration: 200,
    }).start(l.set)

    let g = styler(this.$refs.g)
    tween({
      from: {
        opacity: 0,
        x: '50px',
      },
      to: {
        opacity: 1,
        x: '0px',
      },
      elapsed: -900,
      duration: 200,
    }).start(g.set)
  },

}
</script>

<style scoped>

  [v-cloak] {
    display: none;
  }

  .pageBody {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 0 30px 30px 30px;
    overflow-x: hidden;
  }

  .detailsContainer {
    font-size: 1.5rem;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .linkText {
    color: var(--accent-green);
    text-decoration: none;
    margin: 10px 0;
    white-space: nowrap;
  }

  .viewResume {
    border: none;
    padding: 10px 25px;
    color: var(--background-color);
    text-decoration: none;
    font-size: 1rem;
    font-weight: 800;
    background: var(--accent-green);
    border-radius: 5px;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    width: 100%;
  }

  .viewResume:hover {
    border-radius: 0;
  }

  .contactIcon {
    margin-right: 15px;
    font-size: 1.3rem;
  }

  @media screen and (min-width: 650px) {
   .detailsContainer {
      margin: 200px 20px 0 20px;
    }
  }

</style>